/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_Footer_Desktop_AppsInputs */

const en_app_footer_desktop_apps = /** @type {(inputs: App_Footer_Desktop_AppsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desktop Apps`)
};

const es_app_footer_desktop_apps = /** @type {(inputs: App_Footer_Desktop_AppsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apps de escritorio`)
};

/**
* | output |
* | --- |
* | "Desktop Apps" |
*
* @param {App_Footer_Desktop_AppsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const app_footer_desktop_apps = /** @type {((inputs?: App_Footer_Desktop_AppsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_Footer_Desktop_AppsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_app_footer_desktop_apps(inputs)
	return en_app_footer_desktop_apps(inputs)
});